import type { IconData } from '@stacksjs/iconify-core'

export const medalF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M4 17.502c.307.2.699.26 1.067.133l2.536-.864a1.23 1.23 0 0 1 .794 0l2.536.864c.368.126.76.067 1.067-.133v3.894l-4-1.358l-4 1.358zm3.677-2.37l-2.062.703a1 1 0 0 1-1.222-.51L3.388 13.26a1 1 0 0 0-.43-.447l-2-1.06a1 1 0 0 1-.485-1.181l.71-2.273a1 1 0 0 0 0-.596L.473 5.43a1 1 0 0 1 .486-1.182l1.999-1.06a1 1 0 0 0 .43-.446L4.393.674A1 1 0 0 1 5.615.165l2.062.703a1 1 0 0 0 .646 0l2.062-.703a1 1 0 0 1 1.222.51l1.005 2.066a1 1 0 0 0 .43.447l2 1.06a1 1 0 0 1 .485 1.181l-.71 2.273a1 1 0 0 0 0 .596l.71 2.273a1 1 0 0 1-.486 1.182l-1.999 1.06a1 1 0 0 0-.43.446l-1.005 2.067a1 1 0 0 1-1.222.509l-2.062-.703a1 1 0 0 0-.646 0M8 5a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default medalF
